import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconActionsComponent } from "./med-icon-actions.component";

@NgModule({
  declarations: [
    MedIconActionsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconActionsComponent,
  ],
})
export class MedIconActionsModule { }
